// extracted by mini-css-extract-plugin
export var growableInput = "_5j-0";
export var tagContainer = "_5j-2";
export var textInput = "_5j-1";